module.exports = __webpack_public_path__ + "static/youtube-57bf780e061c230a09cc73b8d76c4700.svg";